// extracted by mini-css-extract-plugin
export var languageSwitcher = "styles-module--languageSwitcher--5f8c9";